import { Command } from 'commands/Commands';

export class ChangeSpecialisations extends Command {
  type: string = 'ChangeSpecialisations';
  priority: number = 100;
}
